module.exports = __webpack_public_path__ + "0cf43afbbc52aba3a877c3e45e00b0bd.svg";